// Vite-style env access. Centralized so other modules don't sprinkle import.meta.env.* everywhere.
// Hardcoded default for the OAuth client secret — matches Tenant.Web's
// public constant in Scripts/utils/constants.tsx. Putting it in source is
// no less secure than putting it in .env (both are committed dev config),
// AND it sidesteps Vite/dotenv-expand mangling the `$` characters as
// variable references.
const DEFAULT_OAUTH_CLIENT_SECRET = 'DOUN#$JDNWJJ453DMO*DN@#$JD*';

export const env = {
  apiUrl: import.meta.env.VITE_API_URL as string,
  oauthClientId: (import.meta.env.VITE_OAUTH_CLIENT_ID as string) || 'web_app',
  oauthClientSecret:
    (import.meta.env.VITE_OAUTH_CLIENT_SECRET as string) || DEFAULT_OAUTH_CLIENT_SECRET,
  appEnv: (import.meta.env.VITE_APP_ENV as 'dev' | 'qa' | 'production') ?? 'dev',
  isDev: import.meta.env.DEV as boolean,
  appInsightsConnectionString: (import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING as string) ?? '',
  // Optional banner text. When set (typically in .env.local for "I'm running my
  // local API against prod data" scenarios), AppShell and LoginPage render a
  // bright red strip across the top so nobody confuses the context.
  appBanner: (import.meta.env.VITE_APP_BANNER as string) ?? '',
  // Public URLs of the two consumer apps. The Test prompts tab builds a
  // role-aware "Test in {patient|provider} app →" deep-link to whichever
  // is appropriate for the prompt — patient for patient-role prompts,
  // provider (hope.anydox.com) for nurse / physician / care-coordinator
  // / pharmacist / admin roles. The chevron next to the button lets the
  // user pick the other app explicitly.
  // When a URL is unset, the corresponding option is hidden — the rest
  // of the tab still works (copy-to-clipboard always available).
  patientAppUrl: (import.meta.env.VITE_PATIENT_APP_URL as string) ?? '',
  providerAppUrl: (import.meta.env.VITE_PROVIDER_APP_URL as string) ?? '',
  // SignalR hub host. Used by the realtime workflow-progress primitives
  // (AIProcessHub + useWorkflowProgress) to connect to /aiprocesshub.
  // Same host the patient + provider apps connect to — process events
  // are merchant-scoped via the JWT-derived Watch(userType, userId) call.
  signalRUrl: (import.meta.env.VITE_SIGNALR_URL as string) ?? '',
};

// Sanity-check at boot. Throws early so misconfigured envs don't fail mysteriously later.
export function validateEnv(): void {
  const required = ['apiUrl', 'oauthClientId'] as const;
  for (const key of required) {
    if (!env[key]) {
      throw new Error(
        `Missing required env var: VITE_${key.replace(/[A-Z]/g, (c) => '_' + c).toUpperCase()}. ` +
          `Check .env.development / .env.local in the project root.`
      );
    }
  }
}
